export const RESET_FORGOT_PASSWORD = "RESET_FORGOT_PASSWORD"
export const RESET_FORGOT_PASSWORD_FAIL = "RESET_FORGOT_PASSWORD_FAIL"
export const RESET_FORGOT_PASSWORD_SUCCESS = "RESET_FORGOT_PASSWORD_SUCCESS"
export const RESET_FORGOT_PASSWORD_RESET = "RESET_FORGOT_PASSWORD_RESET"

export const resetForgotPassword = (params) => {
    return { type: RESET_FORGOT_PASSWORD, params }
}

export const resetForgotPasswordSuccess = (response) => {
    return { type: RESET_FORGOT_PASSWORD_SUCCESS, response }
}

export const resetForgotPasswordFail = (response) => {
    return { type: RESET_FORGOT_PASSWORD_FAIL, response }
}

export const resetForgotPasswordResetState = () => {
    return { type: RESET_FORGOT_PASSWORD_RESET }
}